module.exports = __webpack_public_path__ + "static/media/small-logo.f42adcd7.png";